<template>
  <!-- <v-dialog @click:outside="$emit('closeUploadVideo')" v-model="isUploadVideoDialog" width="360px"> -->
  <v-card
    :class="dragover ? 'container-file-upload-active' : 'container-file-upload'"
    color="transparent"
    width="auto"
    elevation="0"
  >
    <v-card-text>
      <!-- <p class="file-upload-title">{{ $t('fileUploadTitle') }}</p> -->
      <v-card
        @drop.prevent="onDrop($event)"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
        align-self="center"
        class="container-file-upload pa-16"
        color="transparent"
        elevation="0"
      >
        <v-row
          v-if="!uploadedFiles || uploadedFiles === null || uploadedFiles.length <= 0"
          class="d-flex flex-column flex-nowrap"
          dense
          align="center"
          justify="center"
        >
          <p class="file-upload-sub-title">{{ $t('fileUploadContent') }}</p>
          <p class="file-upload-content">{{ $t('fileUploadContent2') }}</p>
          <p class="file-upload-content">- {{ $t('or') }} -</p>

          <v-btn tag="label" color="#31434f" for="uploader-input" class="uploader-input text--white">
            {{ $t('fileUploadBtn') }}
          </v-btn>
          <p v-if="isWrongFile" class="file-upload-failed-content mt-5">{{ $t('fileUploadFailed') }}</p>
        </v-row>
        <v-row v-else class="d-flex flex-column flex-nowrap" dense align="center" justify="center">
          <p class="file-upload-content">{{ $t('fileUploadChecking') }}</p>
          <v-progress-circular indeterminate :size="50" color="primary"></v-progress-circular>
        </v-row>
        <input accept="video/mp4" type="file" id="uploader-input" name="uploader-input" @change="changeFile" />
      </v-card>
    </v-card-text>

    <!-- <v-row align="center" justify="center" class="px-7 pt-3">
      <v-col align="start" class="mb-7" style="color: #eee; font-weight: 700">
        {{ 'Notification' }}
      </v-col>
      <v-col align="end" class="mb-7">
        <notification-dialog
          @customRecipientList="customRecipientList"
          @chkboxWs="chkboxWs"
          @chkboxPostComment="chkboxPostComment"
        ></notification-dialog>
      </v-col>
    </v-row> -->

    <!-- <v-row no-gutters align="center" justify="center">
      <v-col class="px-4" cols="12" align="center" no-gutters>
        <v-btn block color="#96a7af" @click="closeUploadVideo">
          {{ $t('discard') }}
        </v-btn>
      </v-col>
    </v-row> -->
  </v-card>
</template>

<script>
// import NotificationDialog from '@/views/modal/NotificationDialog'
import Toast from '@/views/meeting/component/Toast'
import MP4Box from 'mp4box'

export default {
  name: 'UploadVideoDialog',
  components: {
    // NotificationDialog,
  },
  created() {},
  props: [''],
  data() {
    return {
      dragover: false,
      uploadedFiles: [],
      isWrongFile: false,
      maximumFileSize: 2 * 1024 * 1024 * 1024, // 5GB 제한
    }
  },
  methods: {
    customRecipientList(val) {
      this.$emit('customRecipientList', val)
    },
    chkboxPostComment(val) {
      this.$emit('chkboxPostComment', val)
    },
    chkboxWs(val) {
      this.$emit('chkboxWs', val)
    },
    closeUploadVideo() {
      // Remove all the uploaded files
      this.uploadedFiles = []
      // Close the dialog box
      this.$emit('closeUploadVideo')
    },
    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex((file) => file.name === fileName)
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1)
    },
    onDrop(e) {
      let files = e.dataTransfer.files
      this.isWrongFile = false
      this.dragover = false
      if (files.length > 1) {
        // notify(this, 'Error', this.$t('onlyOneVideo'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('onlyOneVideo'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        return
      }
      let mimeType = files[0].type
      let fileExtention = mimeType.split('/').pop()
      if (fileExtention !== 'mp4') {
        // notify(this, 'Error', this.$t('onlyMp4Video'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('onlyMp4Video'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        return
      }
      this.changeFile(e)
    },
    changeFile(e) {
      this.isWrongFile = false
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      if (files[0].size > this.maximumFileSize) {
        // notify(this, 'Error', this.$t('fileSizeError'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('fileSizeError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        return
      }
      if (this.uploadedFiles.length > 0) this.uploadedFiles = []
      this.uploadedFiles = files

      this.createVideoURI()
    },
    createVideoURI() {
      var reader = new FileReader()
      reader.readAsArrayBuffer(this.uploadedFiles[0])
      reader.onload = (e) => {
        // 파일 정보 체크를 위한 mp4box
        var mp4boxfile = MP4Box.createFile()
        mp4boxfile.onReady = async (info) => {
          let mime = info.mime.replace(/(codecs|profiles|[="])/g, '').split('; ')
          let codecs = mime[1].split(',')

          // MP4 비디오인지 먼저 체크
          let isAcceptableCodec = mime[0] === 'video/mp4'
          if (isAcceptableCodec) {
            // 비디오일 때, 비디오 코덱만 있는 경우와 비디오/사운드 코덱이 같이 있는 경우로 인한 구분
            isAcceptableCodec =
              (codecs.length > 1 && mime[1].includes('avc1') && mime[1].includes('mp4a.40.2')) ||
              (codecs.length === 1 && mime[1].includes('avc1'))
          } else {
            // notify(this, 'Error', this.$t('onlyMp4Video'), 'error')
            this.isWrongFile = true
            this.uploadedFiles = []
            return
          }

          // 코덱 체크도 성공하면 업로드 준비
          if (isAcceptableCodec) {
            let blob = new Blob([e.target.result], {
              type: mime[0],
            })
            let duration
            let timescale = info.timescale && info.timescale !== null ? info.timescale : 1000
            if (info.duration) duration = info.duration / timescale
            this.$emit('saveBlob', {
              blob: blob,
              duration: duration,
            })
          } else {
            // notify(this, 'Error', this.$t('codecError'), 'error')
            this.isWrongFile = true
            this.uploadedFiles = []
            return
          }
        }
        let buffer = e.target.result
        buffer.fileStart = 0
        mp4boxfile.appendBuffer(buffer)
      }
    },
    // submit() {
    //   // If there aren't any files to be uploaded throw error
    //   if (!this.uploadedFiles.length > 0) {
    //     this.$store.dispatch('addNotification', {
    //       message: 'There are no files to upload',
    //       colour: 'error',
    //     })
    //   } else {
    //     // Send uploaded files to parent component
    //     this.$emit('filesUploaded', this.uploadedFiles)
    //     // Close the dialog box
    //     this.closeDialog()
    //   }
    // },
  },
}
</script>

<style scoped>
.container-file-upload-active {
  border-radius: 10px;
  border: solid 5px #ff575f !important;
}
.container-file-upload {
  min-width: 460px;
  border-radius: 10px;
}
@media (max-width: 800px) {
  .container-file-upload {
    min-width: 340px !important;
  }
}
.file-upload-title {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
}
.file-upload-sub-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: white;
}
.file-upload-content {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #869399;
}
.file-upload-failed-content {
  width: 250px !important;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #ff575f;
}
.btn-delete-follow-up {
  color: white;
  font-size: 14px;
  text-transform: none;
}

.container-file-upload >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}

.uploader-input {
  cursor: pointer;
}

#uploader-input {
  width: 0;
  height: 0;
  line-height: 0;
  font-size: 0;
  text-indent: -9999px;
}

.uploader-input img {
  display: block;
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  object-fit: cover;
}
/* .container-v-btn >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
} */
</style>
